if (!customElements.get('product-promo-card')) {
  customElements.define(
    'product-promo-card',
    class ProductPromoCard extends HTMLElement {
      connectedCallback() {
        this.applyButton = this.querySelector('[data-promo-apply]');
        this.applyButton?.addEventListener('click', this.applyDiscount);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange);
        }
      }

      disconnectedCallback() {
        this.applyButton?.removeEventListener('click', this.applyDiscount);
        this.variantChangeUnsubscriber?.();
      }

      applyDiscount = async () => {
        if (this.isApplying) return;
        this.isApplying = true;

        this.showAppliedState();
        this.applyButton?.setAttribute('aria-busy', 'true');

        try {
          await Promise.all([this.copyCode(), this.applyCodeInBackground()]);
        } catch (error) {
          console.warn('Could not apply promo code in the background.', error);
        } finally {
          this.isApplying = false;
          this.applyButton?.removeAttribute('aria-busy');
        }
      };

      async applyCodeInBackground() {
        await this.updateCartDiscount('');
        await this.updateCartDiscount(this.dataset.code);

        const discountUrl = `${this.dataset.discountUrl}?redirect=${encodeURIComponent('/cart.js')}`;
        const response = await fetch(discountUrl, {
          method: 'GET',
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json, text/plain, */*' },
        });

        if (!response.ok) throw new Error(`Discount request failed with status ${response.status}`);
      }

      async updateCartDiscount(code) {
        const response = await fetch(window.routes?.cart_update_url || '/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          cache: 'no-store',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ discount: code }),
        });

        if (!response.ok) throw new Error(`Cart discount update failed with status ${response.status}`);
      }

      async copyCode() {
        try {
          await navigator.clipboard.writeText(this.dataset.code);
        } catch (error) {
          const input = document.createElement('textarea');
          input.value = this.dataset.code;
          input.setAttribute('readonly', '');
          input.style.position = 'fixed';
          input.style.opacity = '0';
          document.body.appendChild(input);
          input.select();
          document.execCommand('copy');
          input.remove();
        }
      }

      showAppliedState() {
        const action = this.querySelector('[data-promo-action]');
        if (action) action.textContent = 'Copied & applied';
        this.classList.add('product-promo-card--applied');
        this.classList.remove('product-promo-card--error');
        this.applyButton?.setAttribute('aria-label', `${this.dataset.code} copied and applied`);
      }

      onVariantChange = ({ data } = {}) => {
        if (!data?.variant || String(data.sectionId) !== String(this.dataset.sectionId)) return;

        const percentage = Number(this.dataset.percentage) || 20;
        const price = Number(data.variant.price) || 0;
        const finalPrice = Math.round(price * (100 - percentage) / 100);

        this.querySelector('[data-promo-final-price]').textContent = this.formatMoney(finalPrice);
        this.querySelector('[data-promo-saving]').textContent = this.formatMoney(price - finalPrice);
      };

      formatMoney(cents) {
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
            style: 'currency',
            currency: this.dataset.currency || 'USD',
          }).format(cents / 100);
        } catch (error) {
          return `$${(cents / 100).toFixed(2)}`;
        }
      }
    }
  );
}
